/* eslint-disable indent */
import { GetStaticPropsContext } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import React from "react";
import { SeoHead } from "../../../containers/components";
import { PageArticle } from "../../../containers/pages/page-article";
import { getPrefooterTypeData } from "../../../services/bestCitiesByType";
import { getFooterCache, getNavBarCache } from "../../../services/cache";
import { StrapiApi } from "../../../services/strapiApi";
import {
  FooterSectionType,
  GetStaticPath,
  NavigationBarType,
  PageArticleType,
  PageBaseProps,
  PageSectionType,
  PageSeo,
  PreFootersType,
} from "../../../types";

export interface NextPageProps {
  navBarSection: PageSectionType<NavigationBarType>;
  footerSection: PageSectionType<FooterSectionType>;
  seo: PageSeo;
  preFooterType: PreFootersType;
  page: PageArticleType;
}

export default function NextPage(props: NextPageProps): JSX.Element {
  return (
    <>
      <SeoHead title={props.seo?.title} description={props.seo?.description} />
      <PageArticle
        page={props.page}
        navBarSection={props.navBarSection}
        footerSection={props.footerSection}
        preFooterType={props.preFooterType}
        overrideLogoUrl={"/blog"}
      />
    </>
  );
}

export async function getStaticProps(
  context: GetStaticPropsContext
): Promise<PageBaseProps> {
  //console.log("LETS GET BLOG ARTICLE");
  const { params, locale, draftMode } = context;
  //console.log({ draftMode });
  const navBarSection = await getNavBarCache();
  const footer = await getFooterCache();
  const page = await StrapiApi.collection_types.pageArticle(
    "fr",
    params?.slug as string,
    draftMode
  );
  return {
    props: {
      ...(await serverSideTranslations(locale ?? "fr")),
      navBarSection: navBarSection,
      footerSection: footer,
      seo: page.seo,
      preFooterType: getPrefooterTypeData(),
      page: page,
    },
    revalidate: Number(process.env.NEXT_PUBLIC_REVALIDATE_TIME),
  };
}

export async function getStaticPaths(): Promise<GetStaticPath> {
  const pages: PageArticleType[] = await StrapiApi.collection_types.allArticles(
    [],
    "fr"
  );

  return {
    paths: pages.map((page) => `/blog/article/${page.slug}`),
    fallback: false,
  };
}
